import { sidebarConfig } from '@ovpn/ui/sidebar';

import { menuLinks } from '@cloud/shared';
import { cssVar } from 'ovpn-ui-toolkit';

/**
 * Legacy dc203 token used for support center authorization.
 */
function getLegacyToken() {
    return document.cookie.split('; ').find(cookie => cookie.match(/^dc203.+$/));
}

function makeSupportUrl() {
    const legacyToken = getLegacyToken();
    const url = window._env_.SUPPORT_HOST;
    return legacyToken ? `${url}?${legacyToken}` : url;
}

export function getDocumentationMenu(isAdmin: boolean) {
    if (isAdmin) {
        return menuLinks.documentation;
    }

    const newChildren = { ...menuLinks.documentation.children };
    newChildren.support.to = makeSupportUrl();
    newChildren.support.target = '_blank';

    return {
        ...menuLinks.documentation,
        children: newChildren,
    };
}

const setSidebarLeftOffset = (offsetPx: number) =>
    cssVar.set('--sidebar-left-offset', `${offsetPx}px`);

export const sidebarOffset = {
    setNone: () => setSidebarLeftOffset(0),
    setTablet: () => setSidebarLeftOffset(sidebarConfig.desktopWidthCollapsed),
    setDesktop: () => setSidebarLeftOffset(sidebarConfig.desktopWidthExpanded),
} as const;
